import { fetch } from 'http-common';

import { PostData } from 'types';
import { ListType } from 'types/api/api.type';
import { BudgetData } from 'types/api/budget.type';

type BudgetList = Omit<ListType, 'content'> & { content: BudgetData[] };

class BudgetDataService {
  private http = fetch();

  private ep = '/v1/budget';

  public async getAll(page?: number, size?: number) {
    return this.http.get<BudgetList>(`${this.ep}/all`, {
      params: {
        page: page || 0,
        limit: size || 10,
      },
    });
  }

  public async getTypes() {
    return this.http.get<any>(`${this.ep}/types`);
  }

  public async create(data: PostData) {
    return this.http.post(`${this.ep}`, data);
  }

  public async delete(
    id: string,
    params: { season: string; seasonLine: string; genderCode: string; zone: string; type: string }
  ) {
    return this.http.delete(`${this.ep}/${id}`, { params });
  }

  public async edit(
    data: PostData,
    id: string,
    params: { season: string; seasonLine: string; genderCode: string; zone: string; type: string }
  ) {
    return this.http.put(`${this.ep}/${id}`, data, { params });
  }

  public async getById(
    id: string,
    params?: { season: string; seasonLine: string; genderCode: string; zone: string; type: string }
  ) {
    return this.http.get<any>(`${this.ep}/${id}`, params ? { params } : undefined);
  }

  public async getByNumAndZone(num: string, zone: string) {
    return this.http.get<any>(`${this.ep}/header/${num}/${zone}`);
  }

  // Reopens a budget sent from the catalogue (clears its "sent" flag) — ADMIN only
  public async reopen(zone: string, budgetNum: number) {
    return this.http.post<string>(`${this.ep}/open/${zone}/${budgetNum}`);
  }

  // Seasons with closed budget data to export, with how many budgets — ADMIN only
  public async getClosedSeasons() {
    return this.http.get<{ season: string; budgets: number }[]>(`${this.ep}/closed/seasons`);
  }

  // 200 = CSV file, 204 = no closed budget data for the season
  public async exportClosed(season: string) {
    return this.http.get<Blob>(`${this.ep}/closed/export`, {
      params: { season },
      responseType: 'blob',
    });
  }
}

const budgetDataService = new BudgetDataService();

export { budgetDataService };
